import React from 'react';
import Name from "./Name";
import Title from "./Title";
import Purpose from "./Purpose";
import { connect } from 'react-redux';


class Metadata extends React.Component {
    
    render() {
        
        return (
            <div className='wizard-inside'>
                <Title/>
                {!(this.props.template.config || {}).siteCustomName && <Name/>}
                <Purpose/>
            </div>
        );
    }
}

const mapStateToProps  = (state)  => ({
    template: state.newSite.Template
})

export default connect(mapStateToProps)(Metadata);





// WEBPACK FOOTER //
// ./src/components/CreateSite/Step2/Metadata.js